import { cn } from "@discovery/classnames";
import { useEffect, useHistory, useState, } from "@discovery/common-dplus/lib/hooks";
import * as M from "@discovery/prelude/lib/data/maybe";
import { pushModuleLinkTracking } from "@discovery/common-dplus/lib/adobe";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { RailTypes } from "../../../component-creators/rails";
import { detectAdblock } from "../../../utils/adBlocker";
import { Button, ButtonVariant } from "../../atoms/button";
import { Link } from "../../atoms/link";
import { HeaderVariants, Tags, Typography } from "../../atoms/typography";
import { Ads, BasicCard, PortraitCard, TopShowCard } from "../cards";
import { PosterCard } from "../cards/card/poster-card";
import { SecondaryCardV2 } from "../cards/card/secondary-card/";
import SquareLogoCarousel from "./_carousel-components/square-logo/index";
import Top10ShowCarousel from "./_carousel-components/top-10-shows-carousel";
import * as styles from "./styles.css";
export const Rail = ({ cards, railType, webAuthRedirectionUrl, ageConstraint, kebabMenuItemHandler, viewAllRoute, gridID, title, BannerId, bannerAdPlaceholder, channelTitle, showTitle, genreCategory, isAdsEnabled, read, hideViewAll, removeFromContinueWatch, }) => {
    const [changes] = useHistory();
    const [currentPath, setCurrentPath] = useState("");
    useEffect(() => {
        //adobe page event requires the url to be set as '/home' instead of '/'
        if (changes.location.pathname === "/") {
            setCurrentPath(config.standardPageRouteFragments.home);
        }
        else {
            setCurrentPath(changes.location.pathname);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [showAd, displayAd] = useState(true);
    const sendAnalyticsEvents = (card, index) => {
        const linkPosition = index + 1;
        card.category &&
            pushModuleLinkTracking(currentPath, linkPosition.toString(), card.name, card.category, "www.discoveryplus.in" + currentPath, card.route);
    };
    const adobeClickEventForSuperstarRails = (card, index) => {
        const linkPosition = index + 1;
        pushModuleLinkTracking(currentPath, linkPosition.toString(), card.name, "superstar", "www.discoveryplus.in" + currentPath, card.route);
    };
    const renderTitle = () => {
        const viewAllNavigation = viewAllRoute && M.fromMaybe(viewAllRoute, "");
        const nativeViewAllUrl = railType !== RailTypes.SuperStars
            ? viewAllNavigation === undefined || viewAllNavigation === ""
                ? config.standardPageRouteFragments.nativeViewAll + "?id=" + gridID
                : viewAllNavigation
            : config.standardPageRouteFragments.nativeViewAll +
                "?id=" +
                gridID +
                "&isSuperStar=true";
        const superstarRailId = railType === RailTypes.SuperStars
            ? "#superstarRailHeading"
            : "#railHeading";
        const showViewAllConstraint = window.innerWidth <= 699 ? 10 : 5;
        return (React.createElement("div", { className: cn(styles.desktopRailHeading, {
                [styles.hideCategoryHeadingInMobile]: railType === RailTypes.CategoryCard ||
                    railType === RailTypes.SquarLogo,
            }), id: superstarRailId },
            React.createElement("div", { id: "railTitle" }, gridID && railType !== RailTypes.FeaturedStandalone && (React.createElement(Typography, { tag: Tags.h5, classNameM: M.of(styles.railTitle), variant: HeaderVariants.headingFive },
                React.createElement(React.Fragment, null, title)))),
            !hideViewAll &&
                railType !== RailTypes.SquarLogo &&
                railType !== RailTypes.CategoryCard &&
                railType !== RailTypes.BasicWithPosition &&
                cards.length >= showViewAllConstraint &&
                gridID && (React.createElement(Link, { href: nativeViewAllUrl },
                React.createElement(Button, { children: "View All", variant: ButtonVariant.Outline, id: "#viewAll" })))));
    };
    const railAds = (index) => {
        const bannerAdProp = {
            bannerId: BannerId,
            bannerAdPlaceholder: bannerAdPlaceholder,
            isAdsEnabled: isAdsEnabled,
        };
        return (showAd && (React.createElement(Ads, { bannerAdProp: bannerAdProp, key: `ad${index}`, channelTitle: channelTitle, showTitle: showTitle, genreCategory: genreCategory })));
    };
    const checkForAdBlocker = () => {
        detectAdblock().then((isDetected) => {
            displayAd(!isDetected);
        });
    };
    const mobileRails = () => {
        const isValidId = showAd && BannerId && BannerId.length > 0;
        return (React.createElement(React.Fragment, null,
            cards.length !== 0 && renderTitle(),
            React.createElement("div", { className: styles.railWrapper },
                React.createElement("div", { className: styles.container },
                    railType === RailTypes.Basic &&
                        cards.slice(0, 10).map((card, index) => isValidId && index === 0 ? (React.createElement("div", { key: index, className: styles.wrap },
                            railAds(index),
                            React.createElement(BasicCard, Object.assign({}, card, { isViewAll: false, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, key: index, read: read })))) : (React.createElement(BasicCard, Object.assign({}, card, { isViewAll: false, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, key: index, index: index, read: read })))),
                    railType === RailTypes.SquarLogo && (React.createElement(SquareLogoCarousel, { cardData: cards })),
                    railType === RailTypes.BasicWithPosition &&
                        cards
                            .slice(0, 10)
                            .map((card, index) => (React.createElement(TopShowCard, Object.assign({}, card, { id: `#cards${index}`, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, key: index, index: index + 1, read: read })))),
                    railType === RailTypes.Descriptive &&
                        cards.slice(0, 10).map((card, index) => {
                            const { isFavoriteM = M.empty() } = card;
                            const isFavorite = M.fromMaybe(isFavoriteM, false);
                            return (React.createElement(SecondaryCardV2, { isFavorite: isFavorite, cardData: card, kebabMenuHandler: kebabMenuItemHandler, hasRoute: true, isFeaturedSecondaryCard: true, key: index, read: read, webAuthRedirectionUrl: webAuthRedirectionUrl }));
                        }),
                    railType === RailTypes.SuperStars &&
                        cards
                            .slice(0, 10)
                            .map((card, index) => (React.createElement(PortraitCard, Object.assign({}, card, { id: `#card${index}`, key: index })))),
                    railType === RailTypes.Poster &&
                        cards
                            .slice(0, 10)
                            .map((card, index) => (React.createElement(PosterCard, Object.assign({}, card, { key: index, ageConstraint: ageConstraint, webAuthRedirectionUrl: webAuthRedirectionUrl, read: read })))),
                    railType === RailTypes.DescriptiveWithProgress &&
                        cards.slice(0, 10).map((card, index) => {
                            const { name = M.empty() } = card;
                            return (React.createElement("div", { className: styles.descriptiveCard, key: index },
                                React.createElement(BasicCard, Object.assign({}, card, { isViewAll: false, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, index: index, railType: railType, read: read, removeFromContinueWatch: removeFromContinueWatch })),
                                React.createElement(Typography, { variant: HeaderVariants.subHeadTwo, tag: Tags.span, classNameM: M.of(styles.description) },
                                    React.createElement(React.Fragment, null, name))));
                        })))));
    };
    const desktopRails = () => {
        const isValidId = BannerId && BannerId.length > 0;
        const showRailAds = showAd && isAdsEnabled && isValidId;
        const endIndex = showRailAds ? 3 : 4;
        return (React.createElement(React.Fragment, null,
            cards.length !== 0 &&
                railType !== RailTypes.CategoryCard &&
                renderTitle(),
            railType === RailTypes.SquarLogo && (React.createElement(SquareLogoCarousel, { cardData: cards })),
            railType === RailTypes.BasicWithPosition && (React.createElement(Top10ShowCarousel, { cards: cards, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, read: read })),
            railType === RailTypes.Poster && (
            //Poster Grid of 6
            React.createElement("div", { className: styles.posterWarpper }, cards.slice(0, 6).map((card, index) => (React.createElement(PosterCard, Object.assign({}, card, { key: index, ageConstraint: ageConstraint, webAuthRedirectionUrl: webAuthRedirectionUrl, read: read, index: index })))))),
            React.createElement("div", { className: styles.desktopRailWarpper, id: "rail" },
                railType === RailTypes.Basic &&
                    // Grid of 4
                    cards.slice(0, endIndex).map((card, index) => index === 0 && showRailAds ? (React.createElement("div", { key: index, className: styles.adContainer },
                        railAds(index),
                        React.createElement(BasicCard, Object.assign({}, card, { isViewAll: false, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, read: read, railType: railType })))) : (React.createElement("div", { key: index, onClick: () => sendAnalyticsEvents(card, index) },
                        React.createElement(BasicCard, Object.assign({}, card, { isViewAll: false, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, key: index, read: read, railType: railType }))))),
                railType === RailTypes.Descriptive &&
                    cards.slice(0, 4).map((card, index) => {
                        const { isFavoriteM = M.empty() } = card;
                        const isFavorite = M.fromMaybe(isFavoriteM, false);
                        return (React.createElement(SecondaryCardV2, { isFavorite: isFavorite, cardData: card, hasRoute: true, key: index, read: read, webAuthRedirectionUrl: webAuthRedirectionUrl }));
                    }),
                railType === RailTypes.SuperStars &&
                    cards.slice(0, 4).map((card, index) => {
                        return (React.createElement("div", { onClick: () => adobeClickEventForSuperstarRails(card, index), key: index },
                            React.createElement(PortraitCard, Object.assign({}, card, { id: `#card${index}` }))));
                    }),
                railType === RailTypes.DescriptiveWithProgress &&
                    cards.slice(0, 4).map((card, index) => {
                        const vType = M.fromMaybe(card.videoType, "");
                        return vType !== "LIVE" ? (React.createElement("div", { className: styles.descriptiveCard, key: index },
                            React.createElement(BasicCard, Object.assign({}, card, { isViewAll: false, railType: railType, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, index: index, read: read, removeFromContinueWatch: removeFromContinueWatch })))) : (React.createElement(React.Fragment, null));
                    }))));
    };
    const isValidId = showAd && BannerId && BannerId.length > 0;
    return (React.createElement(React.Fragment, null,
        railType === RailTypes.Basic && isValidId && checkForAdBlocker(),
        window.innerWidth <= 699 ? mobileRails() : desktopRails()));
};

